// Where an error surfaced, so a failing token endpoint and a failing feed are told apart without a stack.
export enum ErrorSource {
  TokenEndpoint = 'token-endpoint',
  Api = 'api',
  HttpOther = 'http-other',
  OAuth = 'oauth',
  Global = 'global'
}
